"use client";
import { useDataWithAPY } from "@/data";
import React from "react";
import { Smoothup } from "@/components/common/animations";
import { motion } from "framer-motion";
import Image from "next/image";
import { DownloadButtonPair } from "@/components/ui/DownloadButton";

// Import assets with correct paths
import HotAirBalloonImg from "@/assets/images/hero/HotAirBalloon.webp";
import BananaTreeImg from "@/assets/images/decorative/trees/bananatree.webp";
import TreeImg from "@/assets/images/decorative/trees/tree.webp";

export default function CallToActionSection() {
  const data = useDataWithAPY();
  return (
    <section
      id="ctasection"
      className=" relative overflow-hidden bg-[#232526]"
    >
      <Smoothup className="  flex flex-col gap-6 text-white bg-[#232526] my-36 lg:my-24 ">
        <h1 className="z-30 max-w-5xl mx-auto py-2 bg-gradient-to-r from-[#6ACE57] to-[#07C8E6]  inline-block text-transparent bg-clip-text md:text-[4.625rem] md:font-semibold md:leading-[4.625rem] text-center text-[2.75rem] font-semibold leading-[2.75rem]">
          {data.calltoaction.heading}
        </h1>
        <p className=" px-4 md:max-w-sm z-30 mx-auto text-[1.5rem] font-semibold leading-[1.82875rem] text-center">
          {data.calltoaction.subheading}
        </p>
        <div className="flex z-30 sm:justify-center mt-8 px-6 sm:px-0 font-medium flex-col gap-3 sm:text-center">
          {data.calltoaction.list.map((feature, index) => (
            <div
              key={index}
              className="z-30 flex gap-1 items-center sm:justify-center"
            >
              <span>✅</span> {feature}
            </div>
          ))}
        </div>
        <DownloadButtonPair
          className="px-6 sm:px-0 z-30 justify-center items-center mt-[3.2rem]"
          buttonClassName="z-30"
        />
      </Smoothup>

      <motion.div
        initial={{ x: 80 }}
        whileInView={{ x: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
          type: "spring",
          stiffness: 50
        }}
        className=" hidden lg:absolute lg:block w-[40rem] h-[40rem]  -bottom-1 -right-60 "
      >
        <Image
          src={BananaTreeImg}
          alt="banana tree"
          className="w-full h-full object-cover"
        />
      </motion.div>
      <motion.div
        initial={{ x: -80 }}
        whileInView={{ x: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
          type: "spring",
          stiffness: 50
        }}
        className="w-[43rem] h-[43rem] object-cover -bottom-1 -left-[4rem] hidden lg:absolute lg:block "
      >
        <Image
          src={TreeImg}
          alt="tree"
          className="w-full h-full object-cover"
        />
      </motion.div>
      <motion.div
        initial={{ y: 80 }}
        whileInView={{ y: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
          type: "spring",
          stiffness: 50
        }}
        className=" absolute -top-8 md:top-0 -left-10 scale-150 sm:scale-100 md:left-16 xl:left-36 w-[100px] h-[130px] -right-60 "
      >
        <Image
          src={HotAirBalloonImg}
          alt="hot air balloon"
          width={100}
          height={130}
          className="w-full h-full object-cover"
        />
      </motion.div>
      <motion.div
        initial={{ y: 80 }}
        whileInView={{ y: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
          type: "spring",
          stiffness: 50
        }}
        className=" absolute top-10 xl:top-10 blur-sm -right-4 md:right-6 w-[50px] h-[70px] scale-150 sm:scale-100"
      >
        <Image
          src={HotAirBalloonImg}
          alt="hot air balloon"
          width={100}
          height={130}
          className="w-full h-full object-cover"
        />
      </motion.div>
    </section>
  );
}